// import taskAnalysisList from '../components/taskAnalysis/taskAnalysisList.vue'

export default [
    { 
        path: 'taskAnalysis/taskAnalysisList',
        component: resolve => require(['@/components/taskAnalysis/taskAnalysisList'],resolve),
        name:'TaskAnalysisList',
        meta:{
            // id:'926',
            node:'taskAnalysis',
            url:'taskAnalysisList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/taskAnalysis.js